export default __webpack_public_path__ + "static/media/Business.0e0a259d.png";